import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const BlockWrapper = styled.div<{ isSmallCards?: boolean }>`
    width: 100%;
    flex-direction: column;
    margin-bottom: 64px;

    ${p => p.isSmallCards && css`
        padding-left: 16px;
    `}
`;

export const BlockTitle = styled.h2<{ withCarousel?: boolean }>`
    ${FONTS.H2};
    margin-bottom: ${({ withCarousel }) => withCarousel ? '8px' : '32px'};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
        margin-bottom: ${({ withCarousel }) => withCarousel ? 0 : '24px'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: ${({ withCarousel }) => withCarousel ? '8px' : '32px'};
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        max-width: 95%;
    }
`;
